export default {
    pageTitle: 'Chat',
    conversationList: {
        intelligentFilterDisabled: 'Intelligent filter disabled',
        intelligentFilterEnabled: 'Intelligent filter enabled',
        noResults: 'No results.',
        showActive: 'Show active conversations',
        showArchive: 'Show archived conversations',
        showNonActionnable: 'Conversations containing only appointment confirmations, campaign messages or keywords "YES", "NO" and "STOP" won\'t be shown',
        hideNonActionnable: 'All conversations will be shown, including the ones containing only appointment confirmations, campaign messages or keywords "YES", "NO" and "STOP"',
        newConversation: 'New conversation',
        filter: 'Filters',
        seeConversationsOf: 'See conversations of...',
    },
    conversation: {
        youAsSender: 'You',
        picture: '[Picture]',
    },
    newConversation: {
        header: 'New conversation',
        selectContact: 'Select a contact',
        errors: {
            limitExceeded: 'You\'ve reached the limit of separate conversations with this contact.',
            conversationAlreadyExist: 'You\'ve already started a conversation with this contact.',
            failedToRetrieveContact: 'Failed to retrieve contact.',
            noValidPhoneAvailable: 'No valid phone number available.',
            invalidNumberSubtitle: 'Invalid number',
            invalidNumberMessage: 'The contact must have at least one valid phone number in order to create a conversation.',
        },
    },
    message: {
        notDelivered: 'Not delivered',
        notDeliveredNoAccess: 'Not authorized',
        notDeliveredUnreachable: 'This number is a landline or unreachable',
        notDeliveredUnreachableWithRetry: 'This number could not be reached. Click to retry.',
        error: 'An error occured. Click to retry.',
        errorNoAccess: 'You do not have access to write to this contact.',
    },
    messageList: {
        isUnreachable: 'This number ({number}) is a landline or unreachable',
        changePhoneBeforeInteract: 'You must choose or add a valid number to continue',
        contactsSelected: 'contacts selected',
        conversationArchived: 'Conversation archived',
        restoreBeforeInteract: 'You need to restore this conversation before you can interact with that person again.',
        numberUnavailable: 'SMS Number unavailable',
        useNewNumber: 'The number used ({number}) to communicate with this customer is no longer available.',
        numberChange: 'The contact phone was changed to :<br>' +
            '{newNumber} (from {oldNumber})',
        assignNewNumberWithTemplate: 'Use new number',
        numberUnavailablePolestar: 'SMS Number temporarily changed',
        useNewNumberPolestar: 'Due to new regulatory practices in the United States, you must use a new number to message this customer.\n\n' +
            'We’ve automatically inserted a message template to make it easier to explain this change to your customer.\n\n' +
            'To learn more, <a target="_blank" href="https://www.youtube.com/watch?v=OtSSJjXHaao">watch this video</a>.',
        assignNewNumberWithTemplatePolestar: 'Respond with template',
        numberChangeTemplate: 'Hello {clientFullName}, this is {userFullName} from {dealerName}! Last time we spoke ' +
            'I was using {originalNumer}. Due to some regulatory changes, I’ll be using this number from now on. ' +
            'Feel free to reach out to me here at any time.',
        doIt: 'Do you want to do it?',
        restore: 'Restore',
        appointmentTitle: 'Appointment',
        paid: 'Paid',
        paymentTitle: 'Payment',
        received: 'Received',
        statusConfirmed: 'Confirmed',
        byEmail: 'by mail',
        bySms: 'by SMS',
        statusCanceled: 'Canceled',
        statusUnknown: 'Not Confirmed',
        readOnly: 'Read Only',
        notInConversation: 'You are not part of this conversation. To communicate with this client, please start a new conversation.',
        consentExpiration: 'Consent expired',
        consentConfirmed: 'Consent confirmed',
        consentLimitDate: 'Consent expiring on {date}',
        userConsentMoreInfo: "Without the explicit customer's consent, Canada's anti-spam law prevents you from communicating electronically with them as of {date}",
        userUnsubscribed: 'Contact unsubscribed',
        userMustResubscribe: 'The contact must resubscribe to SMS communications to allow you to message him. To do so, he simply needs to text "UNSTOP" to {number}.',
    },
    messageInput: {
        enterMessage: 'Type a message...',
        sendingFailed: 'An error occured while sending the SMS. Please try again.',
        manage: 'Manage...',
        uploadFile: 'Upload file',
        providerPhoneUnavailableTooltip: 'Unable to send message, no provider phone is available, please contact support',
        insertTemplate: 'Insert template',
        addEmoji: 'Emojis',
        templatesModal: {
            header: 'Insert template',
            insert: 'Insert',
        },
        tooltipCount: 'Character count / SMS count',
    },
    messageTemplate: {
        template: 'Message Template',
        builder: 'Message Builder',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        deleteModal: {
            header: 'Delete Template',
            message: 'Are you sure you want to delete this template?',
        },
        newTemplate: 'New Template',
        noTemplate: 'No template',
        noSearchMatch: 'No match for your search',
        templatesList: 'Message templates',
        headerName: 'Name',
        headerContent: 'Message',
        headerCategory: 'Category',
        close: 'Close',
        category: 'Template Category',
        name: 'Template Name',
        placeholdersList: 'Placeholders list',
        subject: 'Subject (emails only)',
    },
    messageTemplateModal: {
        successes: {
            created: 'Template created successfully.',
            updated: 'Template updated successfully.',
            deleted: 'Template deleted successfully.',
        },
        errors: {
            creating: 'Error creating template.',
            updating: 'Error updating template.',
            deleting: 'Error deleting template.',
        },
    },
    templateCategory: {
        category: 'Template Category',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        deleteModal: {
            header: 'Delete Category',
            message: 'Are you sure you want to delete this template category?<br>Associate templates will also be deleted.',
        },
        noCategory: 'No category',
        categoriesList: 'Template Categories',
        headerName: 'Name',
        close: 'Close',
        name: 'Name',
    },
    templateCategoryModal: {
        successes: {
            created: 'Category created successfully.',
            updated: 'Category updated successfully.',
            deleted: 'Category deleted successfully.',
        },
        errors: {
            creating: 'Error creating category.',
            updating: 'Error updating category.',
            deleting: 'Error deleting category.',
        },
    },
    infoBar: {
        activateConversation: 'Restore conversation',
        deactivateConversation: 'Archive conversation',
        accessClientCard: 'View the CRM client card',
        addAppointment: 'Add appointment',
        contactInfos: 'Open contact infos',
        createPayment: 'Create payment',
    },
};
